// Module
var code = "<div class=\"container log-detail-container\">\n    <lb-template-list [log]=\"selectedLog\"></lb-template-list>\n </div>\n";
// Exports
module.exports = code;